<template>
  <div>
    <el-dialog
        :title="'Xuất file chi tiết điểm danh'"
        :visible.sync="isOpenCreateAttendanceEmployeeDetailExcel"
        width="500px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="10vh"
    >
      <el-form
          label-width="100px"
          :model="ruleForm"
          label-position="left"
          :rules="rules"
          ref="ruleForm"
      >
        <el-form-item label="Chọn ngày" required>
          <el-form-item  prop="dateStartEnd">
            <el-date-picker
                v-model="ruleForm.dateStartEnd"
                type="daterange"
                unlink-panels
                range-separator="-"
                style="width: 320px"
                start-placeholder="Ngày bắt đầu"
                end-placeholder="Ngày kết thúc"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
                :clearable="false"
            ></el-date-picker>
          </el-form-item>
        </el-form-item>


        <el-form-item label="Trạng thái" prop="status">
          <!-- chọn trạng thái -->
          <el-select
              class="button-left-status"
              v-model="dataInput.status"
              placeholder="Trạng thái"
              style="width: 320px"
          >
            <el-option
                v-for="item in employeeStatusList"
                :key="item.key"
                :value="item.key"
                :label="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="medium" @click="closeDialog()">
          <i class="el-icon-circle-close" />
          <span>{{ $t("button.close") }}</span>
        </el-button>
        <el-button
            style="margin-right: 40px"
            type="success"
            size="medium"
            :loading="loadingButton"
            mini
            @click="submitForm()"
        >
          <i class="el-icon-circle-check" />
          <span>Xuất file</span>
        </el-button>
      </span>
    </el-dialog>
    <PeopleTypeCreate
        :dialogVisible="showCreateDialog"
        @dialog-close="dialogCloseCreateMethod()"
    />
  </div>
</template>

<script>
import AttendanceEmployeeService from "../../services/EmployeeService/AttendanceEmployeeService";
import {mapState} from "vuex";
import PeopleTypeCreate from "@/views/cashinternal/PeopleTypeCreate.vue";
export default {
  components: {PeopleTypeCreate},
  props: {
    isOpenCreateAttendanceEmployeeDetailExcel: null,
  },

  data() {
    let checkDate = (rule, value, callback) =>{
      if (value.length === 0){
        callback(new Error('Thời gian không được để trống'));
      }else {
        callback();
      }
    }
    return {
      employeeStatusList: [
        { key: "Đang làm", value: "Đang làm" },
        { key: "Tạm nghỉ", value: "Tạm nghỉ" },
        { key: "Nghỉ làm", value: "Nghỉ làm" },
      ],
      // listClass: [],
      dateStartEnd: [],
      value1: [],
      textarea: "",
      typeInternalList: [],
      pickerOptions: {},
      selectDate: "",
      dataInput: {
        status: "Đang làm",
      },
      showCreateDialog: false,
      loadingButton: false,
      ruleForm:{
        dateStartEnd: [],
      },
      rules: {
        dateStartEnd: [
          {
            validator: checkDate,
            trigger: "blur"
          }
        ]
      },
      //css excel
      styleCols1: [],
      styleCols2: [],
      nameCol: {
        name: "",
        style: "",
        numberMerges: 1,
      },
      mergeCells: [],
    };
  },

  created() {
    this.$store.dispatch('classStore/fetchDataClassListCommon');
  },
  computed:{
    ...mapState('classStore',['classListCommon']),
    listClass(){
      return this.classListCommon;
    }
  },
  methods: {
    submitForm() {
      this.$refs.ruleForm.validate((valid) =>{
        if (valid){
          this.loadingButton = true;
          this.$confirm("Bạn có chắc chắn muốn xuất file không?", "Thông báo!", {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }).then(() => {
            this.getStyleExcel();
            // let myDate = moment().format("DD-MM-YYYY hh:mm:ss");
            AttendanceEmployeeService.getExcelExportAttendanceDetail(
                this.ruleForm.dateStartEnd,
                this.dataInput.status
            )
                .then((resp) => {
                  this.loadingButton = false
                  import("@/services/ExportExcel").then((excel) => {
                    let dataResponse = resp.data.data;
                    let dataList = dataResponse.dataList;
                    let fileName = dataResponse.fileName;
                    const tHeader = dataResponse.titleHeaderList;
                    const filterVal = dataResponse.proList;
                    let columnList = [];
                    dataResponse.sizeColumnList.forEach((x) => {
                      let objectInput = {
                        col: x,
                      };
                      columnList.push(objectInput);
                    });
                    let charList = this.$funcData.getRoleListExcel();
                    let style = {
                      font: {bold: true},
                      fill: {fgColor: {rgb: "67C23A"}},
                      border: {
                        top: {style: "thin"},
                        bottom: {style: "thin"},
                        left: {style: "thin"},
                        right: {style: "thin"},
                      },
                    };
                    let styleColData1 = [];
                    let i = 0;
                    tHeader.forEach(() => {
                      styleColData1.push(charList[i] + "5");
                      i++;
                    });
                    let styleCol1 = {
                      name: styleColData1,
                      style,
                    };
                    let styleCol2 = {
                      name: ["A1", "A2", "A3", "A4"],
                      style: {font: {bold: true, color: {rgb: "black"}}},
                    };

                    // Thêm style cho ô gộp D4:H4
                    let styleForMergedCell = {
                      font: {bold: true, color: {rgb: "ffffff"}},
                      fill: {fgColor: {rgb: "4CAF50"}},
                      alignment: {horizontal: "center", vertical: "center"},
                    };

                    this.styleCols1.push(styleCol1);
                    this.styleCols1.push(styleCol2);
                    this.mergeCells.push("D4:I4");

                    this.styleCols1.push({
                      name: ["D4:I4"],
                      style: styleForMergedCell,
                    });

                    excel.export_json_to_excel({
                      header: tHeader,
                      data: dataList,
                      title: filterVal,
                      merges: this.mergeCells,
                      filename: fileName,
                      columnsWidth: columnList,
                      styleCols1: this.styleCols1,
                      styleCols2: this.styleCols2,
                    })
                        .finally(() => {
                          this.styleCols1 = [];
                          this.styleCols2 = [];
                        });
                  });
                })
                .catch((err) => {
                  this.loadingButton = false
                  console.log(err);
                  this.$message({
                    message: "Thất bại",
                    type: "error",
                  });
                });
          }).catch(() =>{
            this.loadingButton = false
          });
        }else {
          this.loadingButton = false
          return false;
        }
      })

    },
    //Style css Excel
    getStyleExcel() {
      let font = this.$styleExcel.fontTitle();
      let alignment = this.$styleExcel.alignmentTitle();
      let border = this.$styleExcel.borderTitle();
      this.nameCol.name = "Tổng";
      this.nameCol.style = {
        fill: {fgColor: {rgb: "3399ff"}},
        font,
        border,
        alignment,
      };

      let styleCol2 = {
        name: "A5:D200",
        style: {
          fill: {fgColor: {rgb: "83a4c4"}},
          font,
          alignment,
          border,
        },
      };

      let styleCol4 = {
        name: "E5:BA50",
        style: {
          fill: {fgColor: {rgb: "d9d290"}},
          font,
          alignment,
          border,
        },
      };
      this.styleCols2.push(styleCol2);
      this.styleCols2.push(styleCol4);
    },

    createDialogMethod() {
      this.showCreateDialog = true;
    },
    dialogCloseCreateMethod() {
      this.showCreateDialog = false;
    },

    //reset when click x
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.loadingButton = false
        this.ruleForm.dateStartEnd = []
        this.dataInput.status = "Đang làm"
        this.$refs["ruleForm"].resetFields();
      }, 300);
    },
  },

};
</script>

<style lang="scss" scoped></style>
